export default "__VITE_ASSET__293599ce__"